export default "__VITE_ASSET__81c10e71__"